import React from 'react';

import { link } from '@aline/routes';
import { Typography } from '@mui/material';
import { StorableIcon } from 'src/components';
import type { Apollo } from 'src/gql/generated';
import { openLink } from 'src/helpers';
import { alineLinkButtonStylesWithUnderlineNotBold, createClampStyles } from 'src/theme';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
    minWidth: 0,
    overflow: 'hidden',
  },
  docName: {
    ...alineLinkButtonStylesWithUnderlineNotBold,
    ...createClampStyles(2),
  },
}));

export type ReminderDocumentType = Pick<
  Apollo.Document,
  'id' | 'name' | 'variant' | '__typename'
> & {
  latestVersion:
    | { __typename: 'DocumentVersion'; id: string }
    | {
        __typename: 'StaticFileVersion';
        fileLocation: { __typename: 'DocFile'; mimetype: string };
        id: string;
      };
};
interface ReminderWithDoc {
  document: ReminderDocumentType;
}

export function ReminderDocument({ reminder }: { reminder: ReminderWithDoc }) {
  const { classes } = useStyles();
  const documentName = reminder.document.name || 'Untitled';

  return (
    <div className={classes.container}>
      <StorableIcon storable={reminder.document} />
      <Typography
        className={classes.docName}
        variant="subtitle2"
        onClick={() => {
          openLink(link.DocumentDetail({ documentId: reminder.document.id }), {
            title: documentName,
          });
        }}
      >
        {documentName}
      </Typography>
    </div>
  );
}
